export const RESET_REVIEW_INVITE = 'REVIEW_INVITE/RESET_REVIEW_INVITE';
export const SET_REVIEW_INVITE_LOCATION =
  'REVIEW_INVITE/SET_REVIEW_INVITE_LOCATION';

export const UPDATE_SEND_VIA = 'REVIEW_INVITE/UPDATE_SEND_VIA';
export const UPDATE_IS_TEST = 'REVIEW_INVITE/UPDATE_IS_TEST';
export const UPDATE_LANGUAGE = 'REVIEW_INVITE/UDPATE_LANGUAGE';
export const UPDATE_SEND_TO = 'REVIEW_INVITE/UPDATE_SEND_TO';
export const UPDATE_CUSTOMER_NAME = 'REVIEW_INVITE/UPDATE_CUSTOMER_NAME';

export const SEND_REVIEW_INVITE_REQUEST =
  'REVIEW_INVITE/SEND_REVIEW_INVITE_REQUEST';
export const SEND_REVIEW_INVITE_SUCCESS =
  'REVIEW_INVITE/SEND_REVIEW_INVITE_SUCCESS';
export const SEND_REVIEW_INVITE_FAILURE =
  'REVIEW_INVITE/SEND_REVIEW_INVITE_FAILURE';
